import React from "react";

import PhotoSelfie from '../../assets/img/sa/selfie_album_top.png';
import PhotoSelfieLogo from '../../assets/img/sa/PHOTOSELFIE.png';

import './PhotoselfieIstruction.css';


const RenderHTML = (props) => {
    return (
        <li className='list-item' dangerouslySetInnerHTML={{__html: props.HTML}}></li>
    );
};


const PhotoselfieIstruction = (props) => {

    const landing_page_enabled = props.landing_page_enabled;
    const textIstruction = props.textIstruction;

    const icona = `<span role="img" aria-label="ok" style={{marginLeft: '0.2rem'}}>&#x1F4F7;</span>`;
    const utent_instruction_nr41 = textIstruction.utent_instruction_nr41.replace('{{icona}}',icona);
    
    return (
        <div>
            <div>
                <img className='img-photoselfie' src={PhotoSelfie} alt='Selfie'/>
            </div>

            <div
                className={landing_page_enabled ? 'landing-page-enabled' : 'landing-page-disabled'}>
                <div className={'introduction'}>
                    <div>
                        <img className='img-photoselfie-logo' src={PhotoSelfieLogo} alt='PhotoSelfie'/>
                    </div>
                    
                    <span className='album-album fontRoboto'>{textIstruction.album}</span>
                    
                    <div className='polygon'>
                        <span className={'fontRoboto'} style={{paddingBottom: '1.5rem', fontSize:'0.9rem'}}>{textIstruction.utent_subtitle}</span>
                    </div>
                </div>
            </div>

            <div className='instruction'>
                <div className='instruction-wrapper'>
                    <p style={{paddingTop: '1rem'}}>{textIstruction.instruction}</p>
                    <ol className='ordered-list fontRoboto' style={{fontSize:'0.9rem', paddingRight:'2rem'}} >
                        <RenderHTML HTML={textIstruction.utent_instruction_nr1}/>
                        <RenderHTML HTML={textIstruction.utent_instruction_nr2}/>
                        <RenderHTML HTML={textIstruction.utent_instruction_nr3}/>
                        <RenderHTML HTML={textIstruction.utent_instruction_nr4}/>
                        <RenderHTML HTML={utent_instruction_nr41}/>
                        <RenderHTML HTML={textIstruction.utent_instruction_NB} />
                    </ol>
                </div>
            </div>

        </div>
        
    )
}

export default PhotoselfieIstruction;


// WEBPACK FOOTER //
// ./src/layouts/Users/PhotoselfieIstruction.js